import styled from "styled-components";

export const Container = styled.div``;

export const Content = styled.div`
  background-color: ${({ theme }) => `${theme.colors.white}`};
  border-bottom: ${({ theme }) =>
    `1px solid ${theme.colors.transactionSecondary}`};
  display: flex;
  justify-content: space-between;
  align-items: center;

  .PhoneInput {
    width: 100%;
  }

  input {
    padding: 0.75rem 0.5rem;
    flex: 1;
    border: none;

    &:focus-visible {
      outline: none;
    }
  }

  svg {
    width: 20px;
    height: 20px;
  }

  @media (min-width: 640px) {
    svg {
      width: 23px;
      height: 23px;
    }
  }
`;
